export function truncateLineInNode(
	text: string | boolean | null | undefined,
	title: string | null = null,
	maxLength: number = 16,
	startChars: number = 6,
	endChars: number = 6
): string {
	let display: string

	if (typeof text === 'boolean') {
		display = text ? 'true' : 'false'
	} else {
		display = String(text)
		if (!display) return ''
		display =
			display.length <= maxLength
				? display
				: display.slice(0, startChars) + '...' + display.slice(-endChars)
	}

	return title ? `${title}: ${display}` : display
}

export function replaceNewlinesWithSpaces(value?: string | null): string {
	if (!value) return ''

	return value.replace(/[\r\n]+/g, ' ')
}
